<template>
  <div class="query-page">
    <van-tabs v-model:active="active" class="brand-tabs" line-width="60" line-height="4" color="#667eea">
      <van-tab :title="$t('query.winningTab')">
        <LotteryDraw />
      </van-tab>
      <van-tab :title="$t('query.rechargeTab')">
        <TopUpList />
      </van-tab>
      <van-tab :title="$t('query.withdrawTab')">
        <WithdrawList />
      </van-tab>
    </van-tabs>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import LotteryDraw from './components/LotteryDraw';
import TopUpList from './components/TopUpList';
import WithdrawList from './components/WithdrawList';
const active = ref(0);
</script>

<style lang="scss" scoped>
.query-page {
  min-height: 100vh;
  background: var(--bg-page);
  padding-bottom: 120px;
}
.brand-tabs :deep(.van-tabs__wrap) {
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}
.brand-tabs :deep(.van-tab) {
  font-size: 28px;
  font-weight: 500;
}
.brand-tabs :deep(.van-tab--active) {
  color: var(--brand-primary);
  font-weight: 600;
}
</style>
